import { getUTCAfternoon, getUTCNow } from '@epicuro-next/utilities';
import { BasketItem, OrderType } from 'graphql-api/baskets-api-interfaces';

export const isBackOrderBasketItem = (basketItem: BasketItem) => {
  if (basketItem.orderType === OrderType.Now) {
    const today = getUTCAfternoon(getUTCNow());
    const deliveryDate = getUTCAfternoon(basketItem.requestedDeliveryDate);
    return deliveryDate > today;
  }

  return false;
};

export const hasBackOrderBasketItems = (basketItems: BasketItem[]) =>
  basketItems.some(isBackOrderBasketItem);
